import { BusinessType } from '@pelicargo/types';
import { AccountType } from '@prisma/client';
import { useLocalStorage } from 'usehooks-ts';

export type TargetAccount = {
  id: number;
  name: string;
  iata_number: string | number;
  is_iata_number_verified: boolean;
  business_type: BusinessType;
  type: AccountType;
  is_fulfillment_partner?: boolean;
};

export const useTargetAccount = () => {
  const [targetAccount, setTargetAccount] = useLocalStorage<TargetAccount>('targetAccount', null);

  return {
    targetAccount,
    changeTargetAccount: setTargetAccount,
  };
};
